import thunk from 'redux-thunk';
import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import { membershipReducer } from '@xo-union/store-membership-redux';
import conversationsReducer, { conversationsMiddleware } from '@xo-union/store-conversations-redux';
import { favoritesReducer, favoriteMiddleware } from '../reducers/favorite-redux';
import { g } from 'xojs/lib/runtime/getGlobal';
import {syncAuthMiddleware, connectAuthSync} from '@tkww/ads-content-component-favorite-button/lib/store';

const initialState = {};

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = g.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducer = combineReducers({
  membership: membershipReducer,
  conversations: conversationsReducer,
  favoriteData: favoritesReducer
});

const enhancers = composeEnhancers(
  applyMiddleware(
    /* Add plugin to tie membership actions to conversations actions */
    conversationsMiddleware(),
    syncAuthMiddleware,
    /* Our libraries depend on thunk */
    thunk
  )
);

const store = createStore(reducer, initialState, enhancers);

if (typeof window !== "undefined") {
  connectAuthSync(store);
}

export default store;
